export default __webpack_public_path__ + "static/media/noun_Speedometer_2171226.42847171.svg";